import { render, staticRenderFns } from "./ExaminationType.vue?vue&type=template&id=74469420&scoped=true"
import script from "./ExaminationType.vue?vue&type=script&lang=js"
export * from "./ExaminationType.vue?vue&type=script&lang=js"
import style0 from "./ExaminationType.vue?vue&type=style&index=0&id=74469420&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74469420",
  null
  
)

export default component.exports